import Link from "src/components/link";
import React from "react";
import styled from "styled-components";
import { Box, Button, Chip, Paper, Stack } from "@mui/material";
import DonutSmallIcon from "@mui/icons-material/DonutSmall";
import { Link as RouteLink } from "react-router-dom";
import { useOrg } from "src/components/providers/org-provider";
import AvatarBadge from "../../components/avatar-badge";

const TeamCardStyled = styled(Paper)`
    height: 172px;
    width: 225px;
    border-radius: 14px;
`;

const TeamNameHeader = styled.h3`
    margin: 13px 0px 0px 0px;
    white-space: nowrap;
    font-size: 14px;
    font-weight: normal;
    padding: 0;
`;

const MembersCounter = styled.div`
    font-size: 12px;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const DashboardButton = styled(Button)`
    background-color: ${({ theme }) => theme.palette.background.default};
    font-size: 12px;
    margin-top: 13px;
    z-index: 10;
`;

const OwnerMemberChip = styled(Chip)`
    color: ${({ theme }) => theme.palette.primary.main};
    height: 18px;
    font-size: 10px;
    border-radius: 2px;
    z-index: 5;
    cursor: pointer;
`;

const OwnerMemberChipSpacer = styled(Chip)`
    color: #474747;
    background-color: #474747;
    height: 18px;
    font-size: 10px;
    z-index: 5;
    cursor: pointer;
`;

const AssignChip = ({ isOwner, isMember }) => {
    if (isOwner === true) {
        return <OwnerMemberChip label="owner" />;
    }
    if (isMember === true && isOwner === false) {
        return <OwnerMemberChip label="member" />;
    }
    return <OwnerMemberChipSpacer label="spacer" />;
};

const TeamCard = ({ team }) => {
    const { org } = useOrg();
    const { name, membersCount, id, picture, isMember, isOwner } = team || {};

    return (
        <Link to={`/teams/${id}`}>
            <TeamCardStyled>
                <Box p={1}>
                    <Stack direction="row" justifyContent="flex-end">
                        <AssignChip isMember={isMember} isOwner={isOwner} />
                    </Stack>
                    <Stack
                        direction="column"
                        alignItems="center"
                        style={{ height: "100%", overflow: "hidden" }}
                    >
                        {(name || picture) && <AvatarBadge name={name} picture={picture} />}
                        {name && <TeamNameHeader>{name}</TeamNameHeader>}
                        {membersCount !== undefined && (
                            <MembersCounter mt={0}>{membersCount} Members</MembersCounter>
                        )}
                        {membersCount < (org.minimumTeamMembers || 3) ? (
                            <DashboardButton startIcon={<DonutSmallIcon />} disabled>
                                Dashboard
                            </DashboardButton>
                        ) : (
                            <DashboardButton
                                component={RouteLink}
                                startIcon={<DonutSmallIcon />}
                                to={`/teams/${id}/dashboard`}
                            >
                                Dashboard
                            </DashboardButton>
                        )}
                    </Stack>
                </Box>
            </TeamCardStyled>
        </Link>
    );
};

export default TeamCard;
